<template>
  <v-container fluid class="py-2 px-0" style="min-height: calc(100vh - 64px);">
    <!-- SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="filteredCollections">
      <!-- FIRST Column -->
      <div class="col-12 ma-0 my-2 pa-0" v-for="(collection, n) in filteredCollections.collections" :key="collection.id + '-' + n">
        <v-divider v-if="n > 0" class="mx-4"></v-divider>
        <m2h-series :collection="collection" :initial-show-all="isCollectionDetail" :is-details="isCollectionDetail"></m2h-series>
      </div>
    </div>
  </v-container>
</template>

<script>

import api from "@/api/api";

export default {
  name: "m2h-browse",
  props: ['categoryId', 'serieId', 'videoId'],
  data() {
    return {
      collections: {},
      categories: {},
      collectionDetails: {}
    }
  },
  
  computed:{
    filteredCollections(){
      if (this.categoryId || this.serieId || this.videoId){
        return this.collectionDetails
      }
      return this.categories
    },
    
    isCollectionDetail(){
      return !!this.categoryId || !!this.serieId || !!this.videoId;
    }
  },

  mounted(){
    if (!this.categoryId && !this.serieId && !this.videoId){
      this.fetchCategories() 
    }
    if (this.categoryId){
      this.fetchCollectionDetails(this.categoryId)
    }
    if (this.serieId){
      this.fetchCollectionDetails(this.serieId)
    }
    if (this.videoId){
      this.fetchVideoDetails(this.videoId)
    }
  },
  
  methods: {

    async fetchCategories(){
      let categories = await api.watch.getCategories().then((res) => { return res.data })
      if (categories){
        this.categories = categories
        if (this.categories.collections && this.categories.collections.length){
          this.categories.collections = this.categories.collections.sort((a, b) => { return a.position - b.position }) 
        }
      }
    },

    async fetchCollectionDetails(id){
      let collectionDetails = await api.watch.getCategoryDetails(id).then((res) => { return res.data })
      if (collectionDetails){
        this.collectionDetails = collectionDetails
        if (this.collectionDetails.collections && this.collectionDetails.collections.length){
          this.collectionDetails.collections = this.collectionDetails.collections.sort((a, b) => { return a.position - b.position })
        }
      }
    },

    async fetchVideoDetails(id){
      let collectionDetails = await api.watch.getMovieDetails(id).then((res) => { return res.data })
      if (collectionDetails){
        this.collectionDetails = collectionDetails
        if (this.collectionDetails.collections && this.collectionDetails.collections.length){
          this.collectionDetails.collections = this.collectionDetails.collections.sort((a, b) => { return a.position - b.position })
        }
      }
    },

    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
  }
}
</script>

<style scoped>

</style>
